import type { CharDashaPeriod, Karaka } from "@/lib/api/char-dasha";

export function PeriodCard({ period, index }: { period: CharDashaPeriod; index: number }) {
  const isFirst = index === 0;
  return (
    <details className="group" open={period.is_current || isFirst}>
      <summary className="flex items-center justify-between cursor-pointer p-3 rounded-lg transition-colors hover:bg-stone-50">
        <div className="flex items-center gap-3">
          <span
            className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-[12px] font-bold"
            style={{
              backgroundColor: period.is_current ? "var(--ish-accent)" : "var(--ish-accent-light)",
              color: period.is_current ? "#fff" : "var(--ish-accent)",
            }}
          >
            {index + 1}
          </span>
          <div>
            <span className="text-[14px] font-semibold" style={{ color: "var(--ish-dark)" }}>
              {period.sign_display} Dasha
            </span>
            {period.is_current && (
              <span
                className="ml-2 text-[11px] font-medium px-2 py-0.5 rounded-full"
                style={{
                  backgroundColor: "var(--ish-accent-light)",
                  color: "var(--ish-accent)",
                }}
              >
                Active Now
              </span>
            )}
          </div>
        </div>
        <div className="text-right">
          <div className="text-[13px] font-medium" style={{ color: "var(--ish-text-faint)" }}>
            {period.years} years
          </div>
          <div className="text-[11px]" style={{ color: "var(--ish-text-faint)" }}>
            {period.start_date.slice(0, 7)} – {period.end_date.slice(0, 7)}
          </div>
        </div>
      </summary>
      <div className="pl-14 pr-3 pb-3">
        <p className="text-[12px] font-semibold mb-1" style={{ color: "var(--ish-text-faint)" }}>
          Sign Lord
        </p>
        <p className="text-[13px] mb-2 font-medium" style={{ color: "var(--ish-dark)" }}>
          {period.lord_display}
        </p>
        <p className="text-[13px] leading-relaxed" style={{ color: "var(--ish-text-muted)" }}>
          {period.theme}
        </p>
      </div>
    </details>
  );
}

export function KarakaCard({ karaka }: { karaka: Karaka }) {
  return (
    <details className="group">
      <summary className="flex items-center justify-between cursor-pointer p-3 rounded-lg transition-colors hover:bg-stone-50">
        <div>
          <span className="text-[13px] font-semibold" style={{ color: "var(--ish-dark)" }}>
            {karaka.role_label}
          </span>
          <span
            className="ml-2 text-[12px] font-medium px-2 py-0.5 rounded-full"
            style={{
              backgroundColor: "var(--ish-accent-light)",
              color: "var(--ish-accent)",
            }}
          >
            {karaka.planet_display}
          </span>
        </div>
        <span className="text-[11px]" style={{ color: "var(--ish-text-faint)" }}>
          {karaka.degree}°
        </span>
      </summary>
      <div className="pl-4 pr-3 pb-3">
        <p className="text-[13px] leading-relaxed" style={{ color: "var(--ish-text-muted)" }}>
          {karaka.description}
        </p>
      </div>
    </details>
  );
}
